// extracted by mini-css-extract-plugin
export default {"customDot":"CustomDot_customDot__63YmC","active":"CustomDot_active__2ywez","inactive":"CustomDot_inactive__ao-On"};